// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/Users/tero.alen/Dev/ajantasalla/src/pages/404.js"),
  "component---src-pages-en-js": require("gatsby-module-loader?name=component---src-pages-en-js!/Users/tero.alen/Dev/ajantasalla/src/pages/en.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/Users/tero.alen/Dev/ajantasalla/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/Users/tero.alen/Dev/ajantasalla/.cache/json/layout-index.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/Users/tero.alen/Dev/ajantasalla/.cache/json/404.json"),
  "en.json": require("gatsby-module-loader?name=path---en!/Users/tero.alen/Dev/ajantasalla/.cache/json/en.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/Users/tero.alen/Dev/ajantasalla/.cache/json/index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/Users/tero.alen/Dev/ajantasalla/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/Users/tero.alen/Dev/ajantasalla/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js